import { Protocol } from '../Protocol';

export class AttributeProtocol {
  public static readonly ALL_ATTRIBUTES: string = `${Protocol.YATUNG_API_ROOT}/attr/all`; // 取得所有屬性
  public static readonly ATTRIBUTE_URL: string = `${Protocol.YATUNG_API_ROOT}/attr`; // 更新 & 新增來源
}
